import CryptoJS from 'crypto-js';

/**
 * Calculate MD5 checksum from a file (matching backend implementation)
 */
export const calculateChecksum = async (file: File): Promise<string> => {
  const arrayBuffer = await file.arrayBuffer();
  const uint8Array = new Uint8Array(arrayBuffer);
  
  // Convert to WordArray for CryptoJS
  const wordArray = CryptoJS.lib.WordArray.create(uint8Array);
  
  // Calculate MD5 hash
  const hash = CryptoJS.MD5(wordArray);
  
  return hash.toString();
};

/**
 * Extract EPSG code from DXF file content
 */
export const extractEpsgFromDxf = async (file: File): Promise<number | null> => {
  try {
    const text = await file.text();
    
    // Look for common EPSG references in DXF files
    const epsgPatterns = [
      /EPSG[:\s]*(\d+)/i,
      /PROJCS.*AUTHORITY\["EPSG","(\d+)"\]/i,
      /GEOGCS.*AUTHORITY\["EPSG","(\d+)"\]/i,
      /\$PROJNAME\s*.*EPSG[:\s]*(\d+)/i,
    ];

    for (const pattern of epsgPatterns) {
      const match = text.match(pattern);
      if (match && match[1]) {
        const epsgCode = parseInt(match[1], 10);
        if (epsgCode > 0) {
          return epsgCode;
        }
      }
    }

    // Default to WGS84 (4326) if no EPSG found
    return 4326;
  } catch (error) {
    console.error("Error extracting EPSG from DXF:", error);
    return null;
  }
};

/**
 * Validate if file is a DXF file
 */
export const validateDxfFile = (file: File): boolean => {
  return file.name.toLowerCase().endsWith('.dxf');
};
